import { render, staticRenderFns } from "./thirdBankAction.vue?vue&type=template&id=55e7945a&scoped=true"
import script from "./thirdBankAction.vue?vue&type=script&lang=js"
export * from "./thirdBankAction.vue?vue&type=script&lang=js"
import style0 from "./thirdBankAction.vue?vue&type=style&index=0&id=55e7945a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7945a",
  null
  
)

export default component.exports